import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
  CardSubtitle,
  Alert,
} from "reactstrap"

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"
import FormButtons from "components/Services/FormComponents/FormButtons"

const StepThree = props => {
  const submitApplicationFormRef = useRef(null)
  const [loading, setloading] = useState(false)

  useEffect(() => {
    setloading(props.loading)
  }, [props.loading])

  const toggleNext = tab => {
    // initiate form submit
    // submit form values to parent form
  }

  const togglePrevious = tab => {
    props.toggleTab(2)
  }

  const toggleSubmit = tab => {
    submitApplicationFormRef.current.click()
  }

  return (
    <>
      <div className="mb-5">
        <form
          onSubmit={e => {
            e.preventDefault()
            props.submit()
          }}
        >
          <Row>
            <div className="row justify-content-center">
              <Col lg="6">
                <div className="text-center">
                  <div className="mb-4">
                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                  </div>
                  <div>
                    <h5>Proceed to submit Application</h5>
                  </div>
                </div>
              </Col>
            </div>
          </Row>
          <Row style={{ display: "none" }}>
            <Col md={12}>
              <button ref={submitApplicationFormRef} type="submit">
                Submit Application
              </button>
            </Col>
          </Row>
        </form>
      </div>
      <FormButtons
        activeTab={3}
        toggleNext={toggleNext}
        togglePrevious={togglePrevious}
        toggleSubmit={toggleSubmit}
        loading={loading}
      />
    </>
  )
}

export default StepThree
